/**
 * Router handler for downgraded components
 *
 * This handles the routing with ui-router. By loading a downgraded component
 * as the single directive on the template we get the Angular component running
 * inside an AngularJS router
 *
 * @param $stateProvider - UI router state provider to handle states
 * @return void
 */
export default function ImportRouter($stateProvider) {
  'ngInject';

  $stateProvider
    .state('app.import-customers', {
      url: '/merchants-import-customers',
      template: '<app-customer-import></app-customer-import>',
      data: {
        authorizedPermissions: ['MERCHANT_IMPORT_CUSTOMERS'],
      },
    })
    .state('app.import-reservations', {
      url: '/merchants-import-reservations',
      template: '<app-reservations-import></app-reservations-import>',
      data: {
        authorizedPermissions: ['MERCHANT_UPDATE'],
      },
    });
}



// WEBPACK FOOTER //
// ./src/app/merchants/importing/import.router.ts